module.exports = __webpack_public_path__ + "img/impfiscales-icon.29a032d1.png";